import axiosCommon from '../helper/axiosCommon'
import qs from 'qs'


async function updateOne(color) {
  const req = axiosCommon.getAxiosParamsAuth(`/colors/${color.id}`, 'put', color)
  return await axiosCommon.axiosRequest(req)
}

async function deleteOne(id) {
  const req = axiosCommon.getAxiosParamsAuth(`/colors/${id}`, 'delete')
  return await axiosCommon.axiosRequest(req)
}

async function createOne(color) {
  const req = axiosCommon.getAxiosParamsAuth('/colors', 'post', color)
  return await axiosCommon.axiosRequest(req)
}

async function readPaginated(query) {
  const req = axiosCommon.getAxiosParamsAuth('/colors?' + qs.stringify(query), 'get')
  return await axiosCommon.axiosRequest(req)
}


export default {
  updateOne,
  deleteOne,
  createOne,
  readPaginated,
}


